export const LOCAL_STORAGE_NAME = {
  TICKET_STATUS_FILTER: 'ticket-status-filter'
}



// WEBPACK FOOTER //
// ./src/constants/general.js